import * as THREE from 'three';
import { Object3D } from "./Viewer.Object3D.js";
import { CSS2DObject } from 'three/addons/renderers/CSS2DRenderer.js';


class DeformedStructureHelper extends Object3D {
    constructor( member, xLoc, displacements, lineMaterial, color ) {
        super();

        this.type = "DeformedStructureHelper";
        this.color = color;
        this.lineMaterial = lineMaterial;

        this.member = member;
        this.xLoc = xLoc;
        this.displacements = displacements;

        this.divs = [];
        this.labels = [];

        this.setScale(1);
    }

    setColor( color ) {
        this.lineMaterial.color.set( color );
        this.divs.forEach(div => {
            div.style.color = color;
        });
    }

    setScale( scale ) {
        if (this.line) {
            this.remove(this.line);
            if (this.line.geometry) {
                this.line.geometry.dispose();
            }
            this.line = null;
        }

        this.labels.forEach(label => {
            this.remove( label );
        });
        this.labels = [];

        this.divs.forEach(div => {
            if (div.parentNode) {
                div.parentNode.removeChild(div);
            }
        });
        this.divs = [];

        const u = this.displacements.x;
        const w = this.displacements.z;

        // const startNode = this.member.startNode.coords;
        // const endNode = this.member.endNode.coords;
        //
        // const dx = endNode[0] - startNode[0];
        // const dz = endNode[2] - startNode[2];

        const points = [];
        this.xLoc.forEach((x, i) => {
            points.push(
                new THREE.Vector3(
                    x + u[i] * scale,
                    0,
                    w[i] * scale
                )
            );
        });

        const geometry = new THREE.BufferGeometry().setFromPoints(points);
        this.line = new THREE.Line(geometry, this.lineMaterial);

        this.add( this.line );


        if (this.displacements.extreme) {
            (this.displacements.extreme.x_local).forEach((x, i) => {
                const z = this.displacements.extreme.values[i];

                if (!(isCloseToZero(z))) {
                    const text = `${ (z * 1000).toFixed(2) }`;

                    const div = this.createLabelElement(text);
                    this.divs.push(div);

                    const label = new CSS2DObject(div);
                    label.position.set(x, 0, z * scale);
                    this.labels.push(label);

                    this.add( label );
                }
            });
        }
    }

    createLabelElement( text ) {
        const div = document.createElement('div');

        div.className = 'displacement-label';
        div.textContent = text;
        div.style.marginTop = '-1em';
        div.style.padding = '2px 4px';
        div.style.borderRadius = '4px';
        div.style.fontSize = '12px';
        div.style.color = this.color;

        return div;
    }

}

function isCloseToZero(value, epsilon = 1e-8) {
    return Math.abs(value) < epsilon;
}

export { DeformedStructureHelper };